import { Grid, Paper, Typography } from "@mui/material";
import get from "lodash.get";
import React from "react";

function Stats(props) {
  const {
    data = [],
    justify = "space-between",
    width = "9rem",
    flexType = "row",
  } = props;

  return (
    <Grid
      style={{
        display: "flex",
        flexDirection: flexType,
        alignItems: "space-between",
        justifyContent: "space-between",
      }}
    >
      {data.map((item, index) => (
        <Paper
          key={index}
          style={{
            display: "flex",
            flexDirection: "column",
            padding: 10,
            margin: 15,
            minWidth: width,
            alignItems: "center",
            justifyContent: "center",
            gap: 10,
            background:
              item.identifier === "total_savings_amount"
                ? "rgba(9, 121, 105,0.8)"
                : "rgba(42,93,180,0.8)",
          }}
        >
          <Typography
            variant="body1"
            component={"b"}
            sx={{ color: "rgba(255, 254, 255, 0.8)", fontSize: "13px" }}
          >
            {item.category}
          </Typography>
          <Typography
            variant="subTitle1"
            component={"p"}
            sx={{ fontSize: "16px", color: "#fff" }}
          >
            {(item.identifier === "total_savings_amount" ||
              item.identifier === "total_approved_amount" ||
              item.identifier === "total_bill_amount") && (
              <span>&#x20b9; </span>
            )}
            {Math.trunc(item.value).toLocaleString("en-IN")}
            {item.identifier === "total_savings_amount" && (
              <b>
                {" "}
                ( {Math.trunc((data[6]?.value / data[4]?.value) * 100)} % )
              </b>
            )}
          </Typography>
        </Paper>
      ))}
    </Grid>
  );
}

export default Stats;
